import React from "react";
import { Form } from "react-bootstrap";
import { MenuItem } from "../../../../../components/@types";
import TimeRangeDropdownFilter from "../../../../../components/TimeRangeDropdownFilter";
import { getTimeRangeMenuItems } from "../menuItems";
import { Selection, Timerange, TimerangeFilter } from "../../../@types";
import { TimeRangeEnum } from "../../../../../lib/enums";
import { DATE_FILTER } from "../../../consts";
import { getSelectedPeriodTimerange, now } from "../../../util";

interface ITimeRangeSelectProps {
  value?: Partial<MenuItem>;
  onChange: (value: MenuItem) => void;
  title: string;
  errors?: string | boolean;
}

export const determineCurrentPeriod = (period?: Partial<Selection>) => {
  const [start, end] = getSelectedPeriodTimerange({
    value: DATE_FILTER.LAST_MONTH,
    label: DATE_FILTER.LAST_MONTH,
    ...period
  });
  return period?.label === DATE_FILTER.CUSTOM
    ? ({ start: start || now, end: end || now } as unknown as Timerange)
    : undefined;
};

const TimeRangeSelect = ({
  value,
  onChange,
  title,
  errors
}: ITimeRangeSelectProps) => (
  <Form.Group>
    <Form.Label className={"form-text--important"}>{title}:</Form.Label>
    <div data-testid={"time-range-select"}>
      <TimeRangeDropdownFilter
        activeFilter={value?.label ?? ""}
        buttonClassname={value?.label ? "" : "default-option"}
        allTitle="All"
        getMenuItems={getTimeRangeMenuItems}
        customTimeRange={determineCurrentPeriod(value)}
        disabled={false}
        title={
          TimeRangeEnum[value?.label as keyof typeof TimeRangeEnum] ??
          "Select from List"
        }
        type="time"
        onlyPeriods={false}
        withoutIcon
        isInvalid={!!errors}
        onTimerangeChange={(timerange: Timerange, filter: TimerangeFilter) => {
          const { start, end } = timerange;
          const { value: newValue } = filter;
          const newSubmissionTime = {
            label: newValue,
            value:
              newValue === DATE_FILTER.CUSTOM
                ? `[${start} TO ${end}]`
                : newValue
          };
          onChange(newSubmissionTime);
        }}
      />
    </div>
  </Form.Group>
);

export default TimeRangeSelect;
